import MyTracker_Icon from "../assets/img/MyTracker_Icon.svg";
import Motocicletas_Icon from "../assets/img/Motocicletas_Icon.svg";
import Botes_Icon from "../assets/img/Botes_Icon.svg";
import AdultosMayores_Icon from "../assets/img/AdultosMayores_Icon.svg";
import Automoviles_Icon from "../assets/img/Automoviles_Icon.svg";
import EquipoPesado_Icon from "../assets/img/EquipoPesado_Icon.svg";
import FlotaMarina_Icon from "../assets/img/FlotaMarina_Icon.svg";
import ManejoDeFlotas_Icon from "../assets/img/ManejoDeFlotas_Icon.svg";
import FuerzaLaboral_Icon from "../assets/img/FuerzaLaboral_Icon.svg";
import Construccion_Icon from "../assets/img/Construccion_Icon.svg";
import TransportePublico_Icon from "../assets/img/TransportePublico_Icon.svg";
import Delivery_Icon from "../assets/img/Delivery_Icon.svg";
import QuienesSomos_Icon from "../assets/img/QuienesSomos_Icon.svg";
import NuestrosClientes_Icon from "../assets/img/NuestrosClientes_Icon.svg";
import NuestroEquipo_Icon from "../assets/img/NuestroEquipo_Icon.svg";
import Carreras_Icon from "../assets/img/Carreras_Icon.svg";
import G_Evolution_Icon from "../assets/img/G_Evolution_Icon.svg";
import Servicios_Icon from "../assets/img/Servicios_Icon.svg";
import Telematics_Icon from "../assets/img/Telematics_Icon.svg";
import Apps_Icon from "../assets/img/Apps_Icon.svg";
import Var_Icon from "../assets/img/Var_Icon.svg";
import UsuarioFinal_Icon from "../assets/img/UsuarioFinal_Icon.svg";
import AlianzasClaves_Icon from "../assets/img/AlianzasClaves_Icon.svg";
import Soporte_Icon from "../assets/img/Soporte_Icon.svg";
import Faqs_Icon from "../assets/img/Faqs_Icon.svg";
import Tutoriales_Icon from "../assets/img/Tutoriales_Icon.svg";

const content = {
	acerca: [
		{
			icon: QuienesSomos_Icon,
			to: "/acerca",
			spanish: {
				boldText: "Quiénes Somos",
				text: "Conoce nuestra trayectoria.",
			},
			english: {
				boldText: "About Us",
				text: "Learn about our trajectory.",
			},
		},
		{
			icon: Carreras_Icon,
			to: "/carreras",
			spanish: {
				boldText: "Carreras",
				text: "Especialízate en el campo de la Geolocalización.",
			},
			english: {
				boldText: "Careers",
				text: "Specialize in the field of Geolocation.",
			},
		},
		{
			icon: NuestrosClientes_Icon,
			to: "/casos-de-exito",
			spanish: {
				boldText: "Casos de Éxito",
				text: "Conoce nuestros clientes y su experiencia.",
			},
			english: {
				boldText: "Success Stories",
				text: "Get to know our clients and their experience.",
			},
		},
		{
			icon: NuestroEquipo_Icon,
			to: "/noticias",
			spanish: {
				boldText: "Noticias",
				text: "¡Conoce las noticias sobre Geolocalización más relevantes!",
			},
			english: {
				boldText: "News",
				text: "¡Find out the most relevant news about Geolocation!",
			},
		},
	],
	industrias: [
		{
			icon: EquipoPesado_Icon,
			to: "/industry/equipo-pesado",
			spanish: {
				boldText: "Manejo de Equipo Pesado",
				text: "Garantice el ahorro de combustible y seguridad de activos.",
			},
			english: {
				boldText: "Heavy Equipment Handling",
				text: "Ensure fuel savings and asset security.",
			},
		},
		{
			icon: ManejoDeFlotas_Icon,
			to: "/industry/manejo-de-flotas",
			spanish: {
				boldText: "Manejo de Flotas",
				text: "Seguimiento en tiempo real de activos pesados.",
			},
			english: {
				boldText: "Fleet Management",
				text: "Real-time tracking of heavy assets.",
			},
		},
		{
			icon: FlotaMarina_Icon,
			to: "/industry/flota-marina",
			spanish: {
				boldText: "Flota Marina",
				text: "Instalamos e integramos sensores en su flota para maximar el rendimiento.",
			},
			english: {
				boldText: "Marine Fleet",
				text: "We install and integrate sensors in your fleet to maximize performance.",
			},
		},
		{
			icon: Delivery_Icon,
			to: "/industry/distribucion",
			spanish: {
				boldText: "Delivery",
				text: "Monitoree sus activos de Distribución.",
			},
			english: {
				boldText: "Delivery",
				text: "Monitor your Distribution assets.",
			},
		},
		{
			icon: Construccion_Icon,
			to: "/industry/construccion",
			spanish: {
				boldText: "Construcción",
				text: "Rastree los activos de su empresa con G-Evolution.",
			},
			english: {
				boldText: "Construction",
				text: "Track your company's assets with G-Evolution.",
			},
		},
		{
			icon: TransportePublico_Icon,
			to: "/industry/transporte",
			spanish: {
				boldText: "Transporte Público y Escolar",
				text: "Mejore la comunicación entre flotas y transporte.",
			},
			english: {
				boldText: "Public and School Transportation",
				text: "Improve communication between fleets and transportation.",
			},
		},
		{
			icon: FuerzaLaboral_Icon,
			to: "/industry/fuerza-laboral",
			spanish: {
				boldText: "Fuerza Laboral de Primera Línea",
				text: "Seguimiento y rastreo de personal VIP.",
			},
			english: {
				boldText: "Essential Workforce",
				text: "VIP personnel tracking and tracing.",
			},
		},
	],
	familias: [
		{
			icon: MyTracker_Icon,
			to: "/family/my-tracker",
			spanish: {
				boldText: "My Tracker",
				text: "Seguimiento en tiempo real para personas VIP.",
			},
			english: {
				boldText: "My Tracker",
				text: "Real time tracking for VIPs.",
			},
		},
		{
			icon: Automoviles_Icon,
			to: "/family/automoviles",
			spanish: {
				boldText: "Automóviles",
				text: "Monitoree en tiempo real sus activos de valor.",
			},
			english: {
				boldText: "Cars",
				text: "Monitor your valuable assets in real time.",
			},
		},
		{
			icon: Botes_Icon,
			to: "/family/botes",
			spanish: {
				boldText: "Botes",
				text: "Gestione su flota con la mejor innovación tecnológica.",
			},
			english: {
				boldText: "Boats",
				text: "Manage your fleet with the best technological innovation.",
			},
		},
		{
			icon: Motocicletas_Icon,
			to: "/family/motocicletas",
			spanish: {
				boldText: "Motocicletas",
				text: "Conozca la locación de su motocicleta.",
			},
			english: {
				boldText: "Motorcycles",
				text: "Know the location of your motorcycle.",
			},
		},
		{
			icon: AdultosMayores_Icon,
			to: "/family/adultos-mayores",
			spanish: {
				boldText: "Adultos Mayores",
				text: "Seguimiento de personas mayores.",
			},
			english: {
				boldText: "Elderly",
				text: "Follow-up of elderly people.",
			},
		},
	],
	soluciones: [
		{
			icon: G_Evolution_Icon,
			to: "/solutions/g-evolution",
			spanish: {
				boldText: "Acerca de GEVOLUTION",
				text: "Nuestra innovadora plataforma de rastreo.",
			},
			english: {
				boldText: "About GEVOLUTION",
				text: "Our innovative tracking platform.",
			},
		},
		{
			icon: Telematics_Icon,
			to: "/solutions/telematica",
			spanish: {
				boldText: "Hardware",
				text: "Nuestra innovadora plataforma de rastreo.",
			},
			english: {
				boldText: "Hardware",
				text: "Our innovative tracking platform.",
			},
		},
		{
			icon: Telematics_Icon,
			to: "/solutions/telematica",
			spanish: {
				boldText: "Carácteristicas",
				text: "Nuestra innovadora plataforma de rastreo.",
			},
			english: {
				boldText: "Features",
				text: "Our innovative tracking platform.",
			},
		},
		{
			icon: Apps_Icon,
			to: "/solutions/aplicaciones-moviles",
			spanish: {
				boldText: "Aplicaciones Móviles",
				text: "Desarrollo de Apps de Rastreo y Geolocalización.",
			},
			english: {
				boldText: "Mobile Applications",
				text: "Development of Tracking and Geolocation Apps.",
			},
		},
		{
			icon: Servicios_Icon,
			to: "/solutions/servicios",
			spanish: {
				boldText: "Servicios",
				text: "Capacidad de generar valor a su negocio o actividad de rastreo.",
			},
			english: {
				boldText: "Services",
				text: "Ability to generate value to your business or tracking activity.",
			},
		},
	],
	aliados: [
		{
			icon: MyTracker_Icon,
			to: "/allies/negocios",
			spanish: {
				boldText: "Negocios (AVL)",
				text: "Rastreo de activos vehiculares.",
			},
			english: {
				boldText: "Business (AVL)",
				text: "Vehicle asset tracking.",
			},
		},
		{
			icon: Var_Icon,
			to: "/allies/revendedor",
			spanish: {
				boldText: "Revendedor de Valor Agregado (VAR)",
				text: "Solución completa y colaboración con particular o empresa.",
			},
			english: {
				boldText: "Value Added Reseller (VAR)",
				text: "Complete solution and collaboration with individuals or companies.",
			},
		},
		{
			icon: AlianzasClaves_Icon,
			to: "/allies/alianzas-claves",
			spanish: {
				boldText: "Alianzas Claves",
				text: "Conoce nuestros aliados de clase mundial.",
			},
			english: {
				boldText: "Key Alliances",
				text: "Meet our world-class partners.",
			},
		},
		{
			icon: UsuarioFinal_Icon,
			to: "/allies/usuario-final",
			spanish: {
				boldText: "Usuario Final",
				text: "Seguridad y logística.",
			},
			english: {
				boldText: "End User",
				text: "Security and logistics.",
			},
		},
	],
	recursos: [
		{
			icon: Soporte_Icon,
			to: "/recursos/soporte",
			spanish: {
				boldText: "Centro de Soporte",
				text: "¡Contáctenos!",
			},
			english: {
				boldText: "Support Center",
				text: "¡Contact us!",
			},
		},
		{
			boldText: "FAQs",
			text: "Preguntas más frecuentes.",
			icon: Faqs_Icon,
			to: "/recursos/preguntas-frecuentes",
			spanish: {
				boldText: "FAQs",
				text: "Preguntas más frecuentes.",
			},
			english: {
				boldText: "FAQs",
				text: "Frequently asked questions.",
			},
		},
		{
			icon: Tutoriales_Icon,
			to: "/recursos/tutoriales",
			spanish: {
				boldText: "Tutoriales",
				text: "Conoce más sobre cómo manejar nuestras plataformas de Geolocalización.",
			},
			english: {
				boldText: "Tutorials",
				text: "Learn more about how to manage our Geolocation platforms.",
			},
		},
	],
};

export default content;
